<script setup>
import ProfileNavbar from "../Navbar/ProfileNavbar.vue";
import FullscreenNavbar from "../Navbar/FullscreenNavbar.vue";
import SearchNavbar from "../Navbar/SearchNavbar.vue";
import BtntoogleNavbar from "./BtntoogleNavbar.vue";
import ColorMode from '@/components/ColorMode.vue';
import VigenciaNavbar from "./VigenciaNavbar.vue";
import { useAuthStore } from '@/stores/auth.js';
const authStore = useAuthStore();

</script>

<template>
    <header class="fixed-top  navlight">
        <!--**********************************
        Nav header start
        ***********************************-->
        <div class="nav-header">
            <a class="navbar-brand align-content-center py-1 px-2" href="/">
                <h3>
                    <span className="text-success">SEAP</span>
                    <span className="text-dark-emphasis"></span>
                </h3>
            </a>
                <BtntoogleNavbar  />
        </div>
        
        <!--**********************************
                Nav header end
        ***********************************-->


        <!--**********************************
        Header start
        ***********************************-->
        <div class="header">
            <div class="header-content">
                <nav class="navbar navbar-expand-lg">
                    <div class="container-fluid">
                        <div class="collapse navbar-collapse justify-content-between" id="navbarNav">
                            <div class="header-left">
                                <!-- <SearchNavbar /> -->
                            </div>
                            <ul class="navbar-nav">
                                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                                    <div class="vr d-none d-lg-flex h-100 mx-lg-2 text-dark-emphasis"></div>
                                </li>
                                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                                    <VigenciaNavbar v-if="authStore && authStore.authUser && authStore?.vigencia"/>
                                </li>
                                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                                    <div class="vr d-none d-lg-flex h-100 mx-lg-2 text-dark-emphasis"></div>
                                </li>
                                <ColorMode />
                                <FullscreenNavbar />
                                <li class="nav-item py-2 py-lg-1 col-12 col-lg-auto">
                                    <div class="vr d-none d-lg-flex h-100 mx-lg-2 text-dark-emphasis"></div>
                                </li>
                                <ProfileNavbar v-if="authStore && authStore.authUser" />
                            </ul>
                        </div>
                    </div>
                </nav>
                <nav class="navbar navbar-expand d-lg-none">
                    <div class="container-fluid">
                        <div class="collapse navbar-collapse flex-row-reverse py-1" id="navbarNav">
                            <ul class=" navbar-nav  align-items-center">
                                <ColorMode />
                                <li>
                                    <ProfileNavbar v-if="authStore && authStore.authUser" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <!--*** Header end ti-comment-alt ****-->
    </header>

</template>

<style scoped>
@keyframes dropdownAnimation {
    from {
        opacity: 0;
        transform: translate3d(0, -30px, 0);
    }

    to {
        opacity: 1;
        transform: none;
        transform: translate3d(0, 0px, 0);
    }
}

.nav-header {
    width: 8rem;
    display: inline-flex;
    text-align: left;
    position: absolute;
    left: auto;
    transition: all .2s ease;
    z-index: 10;
}
.nav-control {
    cursor: pointer;
    text-align: center;
    font-size: 1.4rem;
    margin-top: -5px;
}


.tsytem {
    padding-top: 7px;
}

.header {
    padding: 0rem;
    padding-left: 14rem;
    transition: all .2s ease;
}

/*ALTO NAVBAR, SE AUITA FEBRERO 6 DE 2025*/
/* .header .header-content {
    height: 50px;
} */

.header-left {
    display: flex;
    align-items: center;
    padding: 6px 0px;
}


.header .navbar {
    padding: 0 0;
    width: 100%;
}

.dropdown-menu {
    animation-name: dropdownAnimation;
    -webkit-animation-duration: 0.25s;
    -moz-animation-duration: 0.25s;
    -ms-animation-duration: 0.25s;
    -o-animation-duration: 0.25s;
    animation-duration: 0.25s;
    -webkit-animation-fill-mode: both;
    -moz-animation-fill-mode: both;
    -ms-animation-fill-mode: both;
    -o-animation-fill-mode: both;
    animation-fill-mode: both;
}
</style>
